import {
  IconArrowsSplit,
  IconAt,
  IconBell,
  IconBrandLinkedin,
  IconCalendar,
  IconCalendarClock,
  IconEyeFilled,
  IconHierarchy2,
  IconMail,
  IconMessageCircle,
  IconMessageCircleFilled,
  IconMessageFilled,
  IconMicrophone,
  IconMicrophoneFilled,
  IconPhoneFilled,
  IconRocket,
  IconUserFilled,
  IconUserMinus,
  IconUserPlus,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useThemeStore } from "../../../../../stores/ThemeStore";
import { ThemeIcon, Tooltip } from "@mantine/core";
import { IconGmail } from "../../../../../components/Icons/IconGmail";
import { IconOutlook } from "../../../../../components/Icons/IconOutlook";
import { IconLinkedin } from "../../../../../components/Icons/IconLinkedin";
import { IconEmail } from "../../../../../assets/icons/IconEmail";
import { IconLinkedinWithTip } from "../../../../../components/Icons/IconLinkedinWithTip";

export const nodeSpacingVertical = 48;
export const nodeSpacingHorizontal = 64;
export const nodeWidth = 256;
export const nodeEventWidth = 256;
export const nodeEventHeight = 120;
export const nodeEmailHeight = 164;
export const nodeLinkedinMessageHeight = 172;
export const nodeLinkedinInvitationHeight = 110;
export const nodeLinkedinVisitHeight = 90;
export const nodeHeight = 160;
export const nodeWidthPreview = 480;
export const nodeWidthLinkedinVisitPreview = 300;
export const nodeHeightPreview = 300;

export const maxSalesNavigatorChars = 280;
export const maxNormalChars = 180;

export function getNodeDetails(nodeType, iconProps = { size: 20 }, tipProps) {
  const lang = useLanguage.getState().language;
  const actionColors = useThemeStore.getState().actionColors;
  let node = { icon: "", type: "", label: "", color: "", tip: "" };
  if (nodeType === "email" || nodeType === "Email") {
    node = {
      icon: <IconEmail {...iconProps} />,
      type: "email",
      label: "Email",
      color: "#8964f4",
      tip: lang.workflows.explorer.all_elements.email_tooltip,
    };
  } else if (nodeType === "linkedin") {
    node = {
      icon: <IconUserPlus {...iconProps} />,
      type: "linkedin_invitation",
      label: "LinkedIn",
      color: "#4664e2",
      tip: lang.workflows.explorer.all_elements.linkedin_invitation_tooltip,
    };
  } else if (
    nodeType === "linkedin_invitation" ||
    nodeType === "LinkedinInvitation"
  ) {
    node = {
      icon: (
        <IconLinkedinWithTip
          tipIcon={<IconUserFilled size={10} {...tipProps} color="#4664e2" />}
          fill="#4664e2"
          size={24}
          {...iconProps}
        />
      ),
      type: "linkedin_invitation",
      label: lang.workflows.explorer.all_elements.linkedin_invitation,
      color: "#4664e2",
      tip: lang.workflows.explorer.all_elements.linkedin_invitation_tooltip,
    };
  } else if (
    nodeType === "linkedin_message" ||
    nodeType === "LinkedinMessage"
  ) {
    node = {
      icon: (
        <IconLinkedinWithTip
          tipIcon={
            <IconMessageFilled size={10} {...tipProps} color="#4664e2" />
          }
          fill="#4664e2"
          size={24}
          {...iconProps}
        />
      ),
      type: "linkedin_message",
      label: lang.workflows.explorer.all_elements.linkedin_message,
      color: "#4664e2",
      tip: lang.workflows.explorer.all_elements.linkedin_message_tooltip,
    };
  } else if (nodeType === "linkedin_visit") {
    node = {
      icon: (
        <IconLinkedinWithTip
          tipIcon={<IconEyeFilled size={10} {...tipProps} color="#4664e2" />}
          fill="#4664e2"
          size={24}
          {...iconProps}
        />
      ),
      type: "linkedin_visit",
      label: lang.workflows.explorer.all_elements.linkedin_visit,
      color: "#4664e2",
      tip: lang.workflows.explorer.all_elements.linkedin_visit_tooltip,
    };
  } else if (nodeType === "linkedin_vocal") {
    node = {
      icon: (
        <IconLinkedinWithTip
          tipIcon={
            <IconMicrophoneFilled size={10} {...tipProps} color="#4664e2" />
          }
          fill="#4664e2"
          size={24}
          {...iconProps}
        />
      ),
      type: "linkedin_vocal",
      label: lang.workflows.explorer.all_elements.linkedin_vocal,
      color: "#4664e2",
      tip: lang.workflows.explorer.all_elements.linkedin_vocal_tooltip,
    };
  } else if (nodeType === "sms" || nodeType === "SMS") {
    node = {
      icon: <IconMessageCircleFilled {...iconProps} />,
      type: "sms",
      label: lang.workflows.explorer.all_elements.sms,
      color: "#7ed957",
      tip: lang.workflows.explorer.all_elements.sms_tooltip,
    };
  } else if (nodeType === "smv" || nodeType === "SMV") {
    node = {
      icon: <IconMicrophoneFilled {...iconProps} />,
      type: "smv",
      label: lang.workflows.explorer.all_elements.smv,
      color: "#7ed957",
      tip: lang.workflows.explorer.all_elements.smv_tooltip,
    };
  } else if (nodeType === "event") {
    node = {
      icon: <IconCalendar {...iconProps} />,
      type: "event",
      // label: "Condition",
      label: lang.workflows.explorer.all_elements.add_event,
      color: "#3a2b60",
      tip: lang.workflows.explorer.all_elements.event_tooltip,
    };
  } else if (nodeType === "call") {
    node = {
      icon: <IconPhoneFilled {...iconProps} />,
      type: "call",
      label: lang.workflows.explorer.all_elements.call,
      sub_label: lang.workflows.explorer.all_elements.call_sub,
      color: "#3a2b60",
      tip: lang.workflows.explorer.all_elements.call_tooltip,
    };
  } else if (nodeType === "split_contacts") {
    node = {
      icon: <IconArrowsSplit {...iconProps} />,
      type: "split_contacts",
      label: lang.workflows.explorer.all_elements.split_contacts,
      color: actionColors.split_contacts,
      tip: lang.workflows.explorer.all_elements.split_contacts_tooltip,
    };
  } else if (nodeType === "remove_prospect") {
    node = {
      icon: <IconUserMinus {...iconProps} />,
      type: "remove_prospect",
      label: lang.workflows.explorer.all_elements.remove_prospect,
      color: actionColors.remove_prospect,
      tip: lang.workflows.explorer.all_elements.remove_prospect_tooltip,
    };
  } else if (nodeType === "dummy") {
    node = {
      icon: <IconRocket {...iconProps} />,
      type: "dummy",
      label: lang.workflows.explorer.all_elements.dummy,
      color: actionColors.call,
      tip: lang.workflows.explorer.all_elements.dummy_tooltip,
    };
  }

  return node;
}

export const nodeActions = [
  "email",
  "linkedin_visit",
  "linkedin_invitation",
  "linkedin_message",
  "linkedin_vocal",
  "sms",
  "smv",
  "split_contacts",
];
export const nodeSecondaryActions = ["call", "remove_prospect"];

export function isMainAction(node) {
  if (nodeActions.includes(node?.data?.actionType)) {
    return true;
  }
  return false;
}

export const defaultNodeConfigs = {
  limit_send_per_day: 0,
  time_start_sending: null,
  time_stop_sending: null,
  blacklist_ids: [],
  email_linkedin_exclude: [],
  show_reply_as_conversation: true,
  sending_weekends_allowed: false,
  allow_massmailing: false,
  use_smtp_fallback_server: false,

  when_minutes: 1440,
};

export function getTypeIcon(
  type,
  is_initial,
  iconSize = 18,
  themeIconStyles = { opacity: 0.75 },
  disableTooltip,
  tipProps,
  iconProps
) {
  let lang = useLanguage.getState().language;
  if (type === "Linkedin") {
    return (
      <Tooltip disabled={disableTooltip} label={lang.workflows.types.Linkedin}>
        <ThemeIcon {...themeIconStyles}>
          <IconLinkedin size={iconSize} />
        </ThemeIcon>
      </Tooltip>
    );
  }
  if (type === "MassMailing") {
    return (
      <Tooltip
        disabled={disableTooltip}
        label={
          (is_initial ? lang.workflows.types.initial_action : "") +
          lang.workflows.types.MassMailing
        }
      >
        <ThemeIcon {...themeIconStyles}>
          <IconAt size={iconSize} />
        </ThemeIcon>
      </Tooltip>
    );
  }
  if (type === "SMTP") {
    return (
      <Tooltip
        disabled={disableTooltip}
        label={
          (is_initial ? lang.workflows.types.initial_action : "") +
          lang.workflows.types.SMTP
        }
      >
        <ThemeIcon {...themeIconStyles}>
          <IconEmail size={iconSize} />
        </ThemeIcon>
      </Tooltip>
    );
  }
  if (type === "Outlook") {
    return (
      <Tooltip
        disabled={disableTooltip}
        label={
          (is_initial ? lang.workflows.types.initial_action : "") +
          lang.workflows.types.Outlook
        }
      >
        <ThemeIcon {...themeIconStyles}>
          <IconOutlook size={iconSize} />
        </ThemeIcon>
      </Tooltip>
    );
  }
  if (type === "Gmail") {
    return (
      <Tooltip
        disabled={disableTooltip}
        label={
          (is_initial ? lang.workflows.types.initial_action : "") +
          lang.workflows.types.Gmail
        }
      >
        <ThemeIcon {...themeIconStyles}>
          <IconGmail size={iconSize} />
        </ThemeIcon>
      </Tooltip>
    );
  }
  if (type === "Pool") {
    return (
      <Tooltip
        disabled={disableTooltip}
        label={
          (is_initial ? lang.workflows.types.initial_action : "") +
          lang.workflows.types.Pool
        }
      >
        <ThemeIcon {...themeIconStyles}>
          <IconHierarchy2 size={iconSize} />
        </ThemeIcon>
      </Tooltip>
    );
  }
  if (getNodeDetails(type)?.type) {
    return (
      <Tooltip
        disabled={disableTooltip}
        label={
          (is_initial ? lang.workflows.types.initial_action : "") +
          getNodeDetails(type).label
        }
      >
        <ThemeIcon {...themeIconStyles}>
          {getNodeDetails(type, { size: iconSize, ...iconProps }, tipProps).icon}
        </ThemeIcon>
      </Tooltip>
    );
  }
  return "";
}

export const defaultProgramData = {
  contactlist_ids: [],
  date_start: "",
  daily_send_limit: 0,
  allowed_monday: true,
  allowed_tuesday: true,
  allowed_wednesday: true,
  allowed_thursday: true,
  allowed_friday: true,
  allowed_saturday: false,
  allowed_sunday: false,
  priority_email: false,
  date_stop: "",
  stop_steps_at_end_date: false,
  time_start_sending: "08:00:00",
  time_start_sending_monday: null,
  time_start_sending_tuesday: null,
  time_start_sending_wednesday: null,
  time_start_sending_thursday: null,
  time_start_sending_friday: null,
  time_start_sending_saturday: null,
  time_start_sending_sunday: null,
  time_stop_sending: "20:00:00",
  time_stop_sending_monday: null,
  time_stop_sending_tuesday: null,
  time_stop_sending_wednesday: null,
  time_stop_sending_thursday: null,
  time_stop_sending_friday: null,
  time_stop_sending_saturday: null,
  time_stop_sending_sunday: null,
  limit_total_sending: 0,
  copy_prospect_if_scoring_above: 0,
  ab_proportion: 0,
  ab_subject_2: "",
  ab_subject_3: "",
  resend_to_bounce: false,
  blacklist_ids: [],
  exclude_programmation_ids: [],
};
